import { Type } from "class-transformer";
import { DhcAstItem } from "./DhcAstItem";

export class DhcEvaluatedExpression {
    @Type(() => DhcAstItem)
    astItem: DhcAstItem;
    result: any;
}
